"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mxp_schemas_1 = require("mxp-schemas");
const user_1 = require("../user");
exports.canadaProvinceCodeMap = new Map(Object.entries({
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon',
}));
exports.usaStateCodeMap = new Map(Object.entries({
    AK: 'Alaska',
    AL: 'Alabama',
    AR: 'Arkansas',
    AZ: 'Arizona',
    CA: 'California',
    CNMI: 'Commonwealth of the Northern Mariana Islands',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    IA: 'Iowa',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MA: 'Massachusetts',
    MD: 'Maryland',
    ME: 'Maine',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MS: 'Mississippi',
    MT: 'Montana',
    NC: 'North Carolina',
    ND: 'North Dakota',
    NE: 'Nebraska',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NV: 'Nevada',
    NY: 'New York',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VA: 'Virginia',
    VI: 'Virgin Islands',
    VT: 'Vermont',
    WA: 'Washington',
    WI: 'Wisconsin',
    WV: 'West Virginia',
    WY: 'Wyoming',
}));
exports.EEACountriesList = [
    'AUT',
    'BEL',
    'BGR',
    'HRV',
    'CZE',
    'CYP',
    'DNK',
    'EST',
    'FIN',
    'FRA',
    'DEU',
    'GRC',
    'HUN',
    'ISL',
    'IRL',
    'ITA',
    'LVA',
    'LIE',
    'LTU',
    'LUX',
    'MLT',
    'NLD',
    'NOR',
    'POL',
    'PRT',
    'ROU',
    'SVK',
    'SVN',
    'ESP',
    'SWE',
    'GBR',
];
exports.COUNTRIES_LIST = [
    {
        key: 'US',
        text: 'United States',
        value: 'US',
        ISOAlpha3Code: 'USA',
        territory: '70000001',
        image: '/flags/US.png',
        countryCode: '1',
        validateZipCode: true,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'America',
    },
    {
        key: 'GB',
        text: 'United Kingdom',
        value: 'GB',
        ISOAlpha3Code: 'GBR',
        territory: '20000601',
        image: '/flags/GB.png',
        countryCode: '44',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'CA',
        text: 'Canada',
        value: 'CA',
        ISOAlpha3Code: 'CAN',
        territory: '70000002',
        image: '/flags/CA.png',
        countryCode: '1*',
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'America',
    },
    {
        key: 'AX',
        text: 'Aland Islands',
        value: 'AX',
        image: '/flags/AX.png',
        countryCode: '358',
        ISOAlpha3Code: 'ALA',
        territory: '20000629',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Europe',
    },
    {
        key: 'AL',
        text: 'Albania',
        value: 'AL',
        image: '/flags/AL.png',
        countryCode: '355',
        ISOAlpha3Code: 'ALB',
        territory: '20000203',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'DZ',
        text: 'Algeria',
        value: 'DZ',
        image: '/flags/DZ.png',
        countryCode: '213',
        ISOAlpha3Code: 'DZA',
        territory: '40000206',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Africa',
    },
    {
        key: 'AS',
        text: 'American Samoa',
        value: 'AS',
        image: '/flags/AS.png',
        countryCode: '1-684',
        ISOAlpha3Code: 'ASM',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'AD',
        text: 'Andorra',
        value: 'AD',
        image: '/flags/AD.png',
        countryCode: '376',
        ISOAlpha3Code: 'AND',
        territory: '20000204',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'AO',
        text: 'Angola',
        value: 'AO',
        ISOAlpha3Code: 'AGO',
        territory: '30000101',
        image: '/flags/AO.png',
        countryCode: '244',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'AI',
        text: 'Anguilla',
        value: 'AI',
        ISOAlpha3Code: 'AIA',
        territory: '70000060',
        image: '/flags/AI.png',
        countryCode: '1-264',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'AQ',
        text: 'Antarctica',
        ISOAlpha3Code: 'ATA',
        value: 'AQ',
        image: '/flags/AQ.png',
        countryCode: '672',
    },
    {
        key: 'AG',
        text: 'Antigua and Barbuda',
        value: 'AG',
        image: '/flags/AG.png',
        countryCode: '1-268',
        ISOAlpha3Code: 'ATG',
        territory: '70000006',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'AR',
        text: 'Argentina',
        value: 'AR',
        image: '/flags/AR.png',
        countryCode: '54',
        ISOAlpha3Code: 'ARG',
        territory: '70000007',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'AM',
        text: 'Armenia',
        value: 'AM',
        image: '/flags/AM.png',
        countryCode: '374',
        ISOAlpha3Code: 'ARM',
        territory: '20000403',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'AW',
        text: 'Aruba',
        value: 'AW',
        image: '/flags/AW.png',
        countryCode: '297',
        ISOAlpha3Code: 'ABW',
        territory: '70000008',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'AU',
        text: 'Australia',
        value: 'AU',
        ISOAlpha3Code: 'AUS',
        territory: '50000101',
        image: '/flags/AU.png',
        countryCode: '61',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'AT',
        text: 'Austria',
        value: 'AT',
        ISOAlpha3Code: 'AUT',
        territory: '20000205',
        image: '/flags/AT.png',
        countryCode: '43',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'AZ',
        text: 'Azerbaijan',
        value: 'AZ',
        ISOAlpha3Code: 'AZE',
        territory: '20000404',
        image: '/flags/AZ.png',
        countryCode: '994',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'BS',
        text: 'Bahamas',
        value: 'BS',
        ISOAlpha3Code: 'BHS',
        territory: '70000003',
        image: '/flags/BS.png',
        countryCode: '1-242',
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'BH',
        text: 'Bahrain',
        value: 'BH',
        ISOAlpha3Code: 'BHR',
        territory: '40000401',
        image: '/flags/BH.png',
        countryCode: '973',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'BD',
        text: 'Bangladesh',
        value: 'BD',
        ISOAlpha3Code: 'BGD',
        territory: '40000101',
        image: '/flags/BD.png',
        countryCode: '880',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'BB',
        text: 'Barbados',
        value: 'BB',
        image: '/flags/BB.png',
        countryCode: '1-246',
        ISOAlpha3Code: 'BRB',
        territory: '70000010',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'BE',
        text: 'Belgium',
        value: 'BE',
        ISOAlpha3Code: 'BEL',
        territory: '20000207',
        image: '/flags/BE.png',
        countryCode: '32',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'BZ',
        text: 'Belize',
        value: 'BZ',
        image: '/flags/BZ.png',
        countryCode: '501',
        ISOAlpha3Code: 'BLZ',
        territory: '70000011',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'BJ',
        text: 'Benin',
        value: 'BJ',
        image: '/flags/BJ.png',
        countryCode: '229',
        ISOAlpha3Code: 'BEN',
        territory: '30001302',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'BM',
        text: 'Bermuda',
        value: 'BM',
        ISOAlpha3Code: 'BMU',
        territory: '70000004',
        image: '/flags/BM.png',
        countryCode: '1-441',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'BT',
        text: 'Bhutan',
        value: 'BT',
        image: '/flags/BT.png',
        countryCode: '975',
        ISOAlpha3Code: 'BTN',
        territory: '40000207',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'BO',
        text: 'Bolivia',
        value: 'BO',
        image: '/flags/BO.png',
        countryCode: '591',
        isAmerica: true,
        ISOAlpha3Code: 'BOL',
        territory: '70000013',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'BQ',
        text: 'Bonaire, Sint Eustatius and Saba',
        value: 'BQ',
        image: '/flags/BQ.png',
        countryCode: '599',
        ISOAlpha3Code: 'BES',
        territory: '70000063',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
    },
    {
        key: 'BA',
        text: 'Bosnia and Herzegovina',
        value: 'BA',
        ISOAlpha3Code: 'BIH',
        territory: '20000208',
        image: '/flags/BA.png',
        countryCode: '387',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CountriesFeatureToggleConstants.BLOCKED,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_BOSNIA_HERZEGOVINA,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'BW',
        text: 'Botswana',
        value: 'BW',
        ISOAlpha3Code: 'BWA',
        territory: '30000201',
        image: '/flags/BW.png',
        countryCode: '267',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'BV',
        ISOAlpha3Code: 'BVT',
        text: 'Bouvet Island',
        value: 'BV',
        image: '/flags/BV.png',
        countryCode: '47',
    },
    {
        key: 'BR',
        text: 'Brazil',
        value: 'BR',
        ISOAlpha3Code: 'BRA',
        territory: '70000015',
        image: '/flags/BR.png',
        countryCode: '55',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'IO',
        text: 'British Indian Ocean Territory',
        value: 'IO',
        image: '/flags/IO.png',
        countryCode: '246',
        ISOAlpha3Code: 'IOT',
        territory: '50003008',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'APAC',
    },
    {
        key: 'BN',
        text: 'Brunei',
        value: 'BN',
        ISOAlpha3Code: 'BRN',
        territory: '40000223',
        image: '/flags/BN.png',
        countryCode: '673',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'BG',
        text: 'Bulgaria',
        value: 'BG',
        ISOAlpha3Code: 'BGR',
        territory: '20000505',
        image: '/flags/BG.png',
        countryCode: '359',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'BF',
        text: 'Burkina Faso',
        value: 'BF',
        image: '/flags/BF.png',
        countryCode: '226',
        ISOAlpha3Code: 'BFA',
        territory: '30001304',
        validateZipCode: false,
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.NONE,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'BI',
        ISOAlpha3Code: 'BDI',
        text: 'Burundi',
        value: 'BI',
        image: '/flags/BI.png',
        countryCode: '257',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'KH',
        text: 'Cambodia',
        value: 'KH',
        ISOAlpha3Code: 'KHM',
        territory: '50000011',
        image: '/flags/KH.png',
        countryCode: '855',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'CM',
        text: 'Cameroon',
        value: 'CM',
        image: '/flags/CM.png',
        countryCode: '237',
        ISOAlpha3Code: 'CMR',
        territory: '30001306',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'CV',
        text: 'Cape Verde',
        value: 'CV',
        image: '/flags/CV.png',
        countryCode: '238',
        ISOAlpha3Code: 'CPV',
        territory: '30001307',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'KY',
        text: 'Cayman Islands',
        value: 'KY',
        ISOAlpha3Code: 'CYM',
        territory: '70000003',
        image: '/flags/KY.png',
        countryCode: '1-345',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'CF',
        text: 'Central African Republic',
        ISOAlpha3Code: 'CAF',
        value: 'CF',
        image: '/flags/CF.png',
        countryCode: '236',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'TD',
        text: 'Chad',
        value: 'TD',
        image: '/flags/TD.png',
        countryCode: '235',
        ISOAlpha3Code: 'TCD',
        territory: '30001309',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'CL',
        text: 'Chile',
        value: 'CL',
        image: '/flags/CL.png',
        countryCode: '56',
        ISOAlpha3Code: 'CHL',
        territory: '70000017',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'CN',
        text: 'China',
        value: 'CN',
        ISOAlpha3Code: 'CHN',
        territory: '60030101',
        image: '/flags/CN.png',
        countryCode: '86',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'CX',
        text: 'Christmas Island',
        value: 'CX',
        image: '/flags/CX.png',
        countryCode: '61',
        ISOAlpha3Code: 'CXR',
        territory: '50003001',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'APAC',
    },
    {
        key: 'CC',
        text: 'Cocos (Keeling) Islands',
        value: 'CC',
        image: '/flags/CC.png',
        countryCode: '61',
        ISOAlpha3Code: 'CCK',
        territory: '50003002',
        validateZipCode: false,
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.NONE,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        region: 'APAC',
    },
    {
        key: 'CO',
        text: 'Colombia',
        value: 'CO',
        image: '/flags/CO.png',
        countryCode: '57',
        ISOAlpha3Code: 'COL',
        territory: '70000018',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CountriesFeatureToggleConstants.BLOCKED,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_COLOMBIA,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'KM',
        text: 'Comoros',
        value: 'KM',
        image: '/flags/KM.png',
        countryCode: '269',
        ISOAlpha3Code: 'COM',
        territory: '30001310',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Africa',
    },
    {
        key: 'CG',
        text: 'Congo',
        value: 'CG',
        image: '/flags/CG.png',
        countryCode: '242',
        ISOAlpha3Code: 'COG',
        territory: '30001312',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'CD',
        text: 'Congo, the Democratic Republic of the',
        value: 'CD',
        image: '/flags/CD.png',
        countryCode: '243',
        ISOAlpha3Code: 'COD',
        territory: '30001312',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'AfricaAfrica',
    },
    {
        key: 'CK',
        text: 'Cook Islands',
        value: 'CK',
        image: '/flags/CK.png',
        countryCode: '682',
        ISOAlpha3Code: 'COK',
        territory: '50003009',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'CR',
        text: 'Costa Rica',
        value: 'CR',
        image: '/flags/CR.png',
        countryCode: '506',
        ISOAlpha3Code: 'CRI',
        territory: '70000019',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'CI',
        text: "Cote D'Ivoire",
        value: 'CI',
        image: '/flags/CI.png',
        countryCode: '225',
        ISOAlpha3Code: 'CIV',
        territory: '30001313',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'HR',
        text: 'Croatia',
        value: 'HR',
        image: '/flags/HR.png',
        countryCode: '385',
        ISOAlpha3Code: 'HRV',
        territory: '20000209',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'CW',
        text: 'Curacao',
        value: 'CW',
        ISOAlpha3Code: 'CUW',
        territory: '70000005',
        image: '/flags/CW.png',
        countryCode: '599',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        region: 'Europe',
        isAmerica: true,
    },
    {
        key: 'CY',
        text: 'Cyprus',
        value: 'CY',
        image: '/flags/CY.png',
        countryCode: '357',
        ISOAlpha3Code: 'CYP',
        territory: '20000210',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'CZ',
        text: 'Czech Republic',
        value: 'CZ',
        ISOAlpha3Code: 'CZE',
        territory: '20000506',
        image: '/flags/CZ.png',
        reformatZipcode: true,
        countryCode: '420',
        allowAliasChange: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CZECH_REPUBLIC,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CZECH_REPUBLIC,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'DK',
        text: 'Denmark',
        value: 'DK',
        image: '/flags/DK.png',
        countryCode: '45',
        ISOAlpha3Code: 'DNK',
        territory: '20000211',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'DJ',
        text: 'Djibouti',
        value: 'DJ',
        image: '/flags/DJ.png',
        countryCode: '253',
        ISOAlpha3Code: 'DJI',
        territory: '30001314',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'DM',
        text: 'Dominica',
        value: 'DM',
        image: '/flags/DM.png',
        countryCode: '1-767',
        isAmerica: true,
        ISOAlpha3Code: 'DMA',
        territory: '70000022',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'DO',
        text: 'Dominican Republic',
        value: 'DO',
        image: '/flags/DO.png',
        countryCode: '1-809',
        ISOAlpha3Code: 'DOM',
        territory: '70000023',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'EC',
        text: 'Ecuador',
        value: 'EC',
        image: '/flags/EC.png',
        countryCode: '593',
        ISOAlpha3Code: 'ECU',
        territory: '70000024',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'EG',
        text: 'Egypt',
        value: 'EG',
        ISOAlpha3Code: 'EGY',
        territory: '40000203',
        image: '/flags/EG.png',
        countryCode: '20',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Africa',
    },
    {
        key: 'SV',
        text: 'El Salvador',
        value: 'SV',
        image: '/flags/SV.png',
        countryCode: '503',
        ISOAlpha3Code: 'SLV',
        territory: '70000025',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'GQ',
        text: 'Equatorial Guinea',
        value: 'GQ',
        image: '/flags/GQ.png',
        countryCode: '240',
        ISOAlpha3Code: 'GNQ',
        territory: '30001315',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'ER',
        text: 'Eritrea',
        value: 'ER',
        image: '/flags/ER.png',
        countryCode: '291',
        ISOAlpha3Code: 'ERI',
        territory: '30001316',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'EE',
        text: 'Estonia',
        value: 'EE',
        image: '/flags/EE.png',
        countryCode: '372',
        ISOAlpha3Code: 'EST',
        territory: '20000212',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'SZ',
        text: 'Eswatini (formerly Swaziland)',
        value: 'SZ',
        ISOAlpha3Code: 'SWZ',
        territory: '30001344',
        image: '/flags/SZ.png',
        countryCode: '268',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'ET',
        text: 'Ethiopia',
        value: 'ET',
        image: '/flags/ET.png',
        countryCode: '251',
        ISOAlpha3Code: 'ETH',
        territory: '30001317',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_APPROVED_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'FK',
        text: 'Falkland Islands',
        value: 'FK',
        image: '/flags/FK.png',
        countryCode: '500',
        ISOAlpha3Code: 'FLK',
        territory: '70000062',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'FO',
        text: 'Faroe Islands',
        value: 'FO',
        image: '/flags/FO.png',
        countryCode: '298',
        ISOAlpha3Code: 'FRO',
        territory: '20000626',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'FJ',
        text: 'Fiji',
        value: 'FJ',
        image: '/flags/FJ.png',
        countryCode: '679',
        ISOAlpha3Code: 'FJI',
        territory: '50000015',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'FI',
        text: 'Finland',
        value: 'FI',
        image: '/flags/FI.png',
        countryCode: '358',
        ISOAlpha3Code: 'FIN',
        territory: '20000214',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'FR',
        text: 'France',
        value: 'FR',
        ISOAlpha3Code: 'FRA',
        territory: '20000215',
        image: '/flags/FR.png',
        countryCode: '33',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'GF',
        text: 'French Guiana',
        value: 'GF',
        image: '/flags/GF.png',
        countryCode: '594',
        ISOAlpha3Code: 'GUF',
        territory: '70000070',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'PF',
        text: 'French Polynesia',
        value: 'PF',
        image: '/flags/PF.png',
        countryCode: '689',
        ISOAlpha3Code: 'PYF',
        territory: '50003010',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TF',
        text: 'French Southern Territories',
        ISOAlpha3Code: 'ATF',
        value: 'TF',
        image: '/flags/TF.png',
        countryCode: '262',
        region: 'Europe',
    },
    {
        key: 'GA',
        text: 'Gabon',
        value: 'GA',
        image: '/flags/GA.png',
        countryCode: '241',
        ISOAlpha3Code: 'GAB',
        territory: '30001319',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GM',
        text: 'Gambia',
        value: 'GM',
        image: '/flags/GM.png',
        countryCode: '220',
        ISOAlpha3Code: 'GMB',
        territory: '30001320',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GE',
        text: 'Georgia',
        value: 'GE',
        ISOAlpha3Code: 'GEO',
        territory: '20000216',
        image: '/flags/GE.png',
        countryCode: '995',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'DE',
        text: 'Germany',
        value: 'DE',
        ISOAlpha3Code: 'DEU',
        territory: '20000501',
        image: '/flags/DE.png',
        countryCode: '49',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'GH',
        text: 'Ghana',
        value: 'GH',
        ISOAlpha3Code: 'GHA',
        territory: '30000301',
        image: '/flags/GH.png',
        countryCode: '233',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GI',
        text: 'Gibraltar',
        value: 'GI',
        ISOAlpha3Code: 'GIB',
        territory: '20000249',
        image: '/flags/GI.png',
        countryCode: '350',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'GR',
        text: 'Greece',
        value: 'GR',
        ISOAlpha3Code: 'GRC',
        territory: '20000217',
        image: '/flags/GR.png',
        countryCode: '30',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'GL',
        text: 'Greenland',
        value: 'GL',
        image: '/flags/GL.png',
        countryCode: '299',
        ISOAlpha3Code: 'GRL',
        territory: '20000625',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'GD',
        text: 'Grenada',
        value: 'GD',
        image: '/flags/GD.png',
        countryCode: '1-473',
        isAmerica: true,
        ISOAlpha3Code: 'GRD',
        territory: '70000028',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'GP',
        text: 'Guadeloupe',
        value: 'GP',
        image: '/flags/GP.png',
        countryCode: '590',
        ISOAlpha3Code: 'GLP',
        territory: '70000064',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'GU',
        text: 'Guam',
        value: 'GU',
        image: '/flags/GU.png',
        countryCode: '1-671',
        ISOAlpha3Code: 'GUM',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'GT',
        text: 'Guatemala',
        value: 'GT',
        image: '/flags/GT.png',
        countryCode: '502',
        ISOAlpha3Code: 'GTM',
        territory: '70000030',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        isAmerica: true,
        region: 'America',
    },
    {
        key: 'GG',
        text: 'Guernsey',
        value: 'GG',
        image: '/flags/GG.png',
        countryCode: '44-1481',
        ISOAlpha3Code: 'GGY',
        territory: '20000622',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        region: 'Europe',
    },
    {
        key: 'GN',
        text: 'Guinea',
        value: 'GN',
        image: '/flags/GN.png',
        countryCode: '224',
        ISOAlpha3Code: 'GIN',
        territory: '30001348',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GW',
        text: 'Guinea-Bissau',
        value: 'GW',
        ISOAlpha3Code: 'GNB',
        image: '/flags/GW.png',
        countryCode: '245',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GY',
        text: 'Guyana',
        value: 'GY',
        image: '/flags/GY.png',
        countryCode: '592',
        ISOAlpha3Code: 'GUY',
        territory: '70000031',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'HT',
        text: 'Haiti',
        value: 'HT',
        image: '/flags/HT.png',
        countryCode: '509',
        ISOAlpha3Code: 'HTI',
        territory: '70000032',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'HM',
        text: 'Heard and McDonald Islands',
        value: 'HM',
        ISOAlpha3Code: 'HMD',
        image: '/flags/HM.png',
        countryCode: '672',
        region: 'APAC',
    },
    {
        key: 'HN',
        text: 'Honduras',
        value: 'HN',
        image: '/flags/HN.png',
        countryCode: '504',
        ISOAlpha3Code: 'HND',
        territory: '70000033',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_5,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'HK',
        text: 'Hong Kong SAR, China',
        value: 'HK',
        ISOAlpha3Code: 'HKG',
        territory: '60020001',
        image: '/flags/HK.png',
        useSuperAdminArea: true,
        countryCode: '852',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'North Asia',
    },
    {
        key: 'HU',
        text: 'Hungary',
        value: 'HU',
        image: '/flags/HU.png',
        countryCode: '36',
        ISOAlpha3Code: 'HUN',
        territory: '20000507',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'IS',
        text: 'Iceland',
        value: 'IS',
        image: '/flags/IS.png',
        countryCode: '354',
        ISOAlpha3Code: 'ISL',
        territory: '20000220',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'IN',
        text: 'India',
        value: 'IN',
        ISOAlpha3Code: 'IND',
        territory: '50020001',
        image: '/flags/IN.png',
        countryCode: '91',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'ID',
        text: 'Indonesia',
        value: 'ID',
        ISOAlpha3Code: 'IDN',
        territory: '50000001',
        image: '/flags/ID.png',
        countryCode: '62',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'IQ',
        text: 'Iraq',
        value: 'IQ',
        image: '/flags/IQ.png',
        countryCode: '964',
        ISOAlpha3Code: 'IRQ',
        territory: '40000210',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'IE',
        text: 'Ireland',
        value: 'IE',
        ISOAlpha3Code: 'IRL',
        territory: '20000101',
        image: '/flags/IE.png',
        countryCode: '353',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'IM',
        text: 'Isle of Man',
        value: 'IM',
        image: '/flags/IM.png',
        countryCode: '44-1624',
        ISOAlpha3Code: 'IMN',
        territory: '20000631',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'Europe',
    },
    {
        key: 'IL',
        text: 'Israel',
        value: 'IL',
        image: '/flags/IL.png',
        countryCode: '972',
        ISOAlpha3Code: 'ISR',
        territory: '40000211',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'IT',
        text: 'Italy',
        value: 'IT',
        ISOAlpha3Code: 'ITA',
        territory: '20000221',
        image: '/flags/IT.png',
        countryCode: '39',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'JM',
        text: 'Jamaica',
        value: 'JM',
        ISOAlpha3Code: 'JAM',
        territory: '70000034',
        image: '/flags/JM.png',
        countryCode: '1-876',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'JP',
        text: 'Japan',
        value: 'JP',
        ISOAlpha3Code: 'JPN',
        territory: '60040001',
        image: '/flags/JP.png',
        countryCode: '81',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'JE',
        text: 'Jersey',
        value: 'JE',
        image: '/flags/JE.png',
        countryCode: '44-1534',
        ISOAlpha3Code: 'JEY',
        territory: '20000623',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        region: 'Europe',
    },
    {
        key: 'JO',
        text: 'Jordan',
        value: 'JO',
        ISOAlpha3Code: 'JOR',
        territory: '40000212',
        image: '/flags/JO.png',
        countryCode: '962',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'KZ',
        text: 'Kazakhstan',
        value: 'KZ',
        ISOAlpha3Code: 'KAZ',
        territory: '20000405',
        image: '/flags/KZ.png',
        countryCode: '7',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'KE',
        text: 'Kenya',
        value: 'KE',
        ISOAlpha3Code: 'KEN',
        territory: '30000401',
        image: '/flags/KE.png',
        countryCode: '254',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'KI',
        text: 'Kiribati',
        value: 'KI',
        image: '/flags/KI.png',
        countryCode: '686',
        ISOAlpha3Code: 'KIR',
        territory: '50000017',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'KR',
        text: 'Korea, the Republic of',
        value: 'KR',
        ISOAlpha3Code: 'KOR',
        territory: '60040003',
        image: '/flags/KR.png',
        countryCode: '82',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'XK',
        text: 'Kosovo',
        value: 'XK',
        ISOAlpha3Code: 'XKX',
        territory: '20000627',
        image: '/flags/XK.png',
        countryCode: '383',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'KW',
        text: 'Kuwait',
        value: 'KW',
        ISOAlpha3Code: 'KWT',
        territory: '40000402',
        image: '/flags/KW.png',
        countryCode: '965',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'KG',
        text: 'Kyrgyzstan',
        value: 'KG',
        image: '/flags/KG.png',
        countryCode: '996',
        ISOAlpha3Code: 'KGZ',
        territory: '20000222',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'LA',
        text: "Lao People's Democratic Republic",
        value: 'LA',
        image: '/flags/LA.png',
        countryCode: '856',
        ISOAlpha3Code: 'LAO',
        territory: '50000018',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'LV',
        text: 'Latvia',
        value: 'LV',
        ISOAlpha3Code: 'LVA',
        image: '/flags/LV.png',
        countryCode: '371',
        territory: '20000223',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'LB',
        text: 'Lebanon',
        value: 'LB',
        image: '/flags/LB.png',
        countryCode: '961',
        ISOAlpha3Code: 'LBN',
        territory: '40000214',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_APPROVED_B2C,
        isRestricted: true,
        tier: mxp_schemas_1.Checkout.Tiers.RESTRICTED,
        region: 'APAC',
    },
    {
        key: 'LS',
        text: 'Lesotho',
        value: 'LS',
        ISOAlpha3Code: 'LSO',
        territory: '30001324',
        image: '/flags/LS.png',
        countryCode: '266',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'LR',
        text: 'Liberia',
        value: 'LR',
        image: '/flags/LR.png',
        countryCode: '231',
        ISOAlpha3Code: 'LBR',
        territory: '30001325',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'LY',
        text: 'Libya',
        value: 'LY',
        ISOAlpha3Code: 'LBY',
        image: '/flags/LY.png',
        countryCode: '218',
        isRestricted: true,
        tier: mxp_schemas_1.Checkout.Tiers.RESTRICTED,
        region: 'Africa',
    },
    {
        key: 'LI',
        text: 'Liechtenstein',
        value: 'LI',
        image: '/flags/LI.png',
        countryCode: '423',
        ISOAlpha3Code: 'LIE',
        territory: '20000224',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'LT',
        text: 'Lithuania',
        value: 'LT',
        ISOAlpha3Code: 'LTU',
        territory: '20000225',
        image: '/flags/LT.png',
        countryCode: '370',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'LU',
        text: 'Luxembourg',
        value: 'LU',
        ISOAlpha3Code: 'LUX',
        territory: '20000226',
        image: '/flags/LU.png',
        countryCode: '352',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'MO',
        text: 'Macao SAR, China',
        value: 'MO',
        ISOAlpha3Code: 'MAC',
        territory: '60020002',
        image: '/flags/MO.png',
        countryCode: '853',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'MK',
        text: 'Macedonia',
        value: 'MK',
        image: '/flags/MK.png',
        countryCode: '389',
        ISOAlpha3Code: 'MKD',
        territory: '20000227',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'MG',
        text: 'Madagascar',
        value: 'MG',
        image: '/flags/MG.png',
        countryCode: '261',
        ISOAlpha3Code: 'MDG',
        territory: '30001326',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'MW',
        text: 'Malawi',
        value: 'MW',
        ISOAlpha3Code: 'MWI',
        territory: '30000501',
        image: '/flags/MW.png',
        countryCode: '265',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'MY',
        text: 'Malaysia',
        value: 'MY',
        ISOAlpha3Code: 'MYS',
        territory: '50000002',
        image: '/flags/MY.png',
        countryCode: '60',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'MV',
        text: 'Maldives',
        value: 'MV',
        image: '/flags/MV.png',
        countryCode: '960',
        ISOAlpha3Code: 'MDV',
        territory: '40000201',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'ML',
        text: 'Mali',
        value: 'ML',
        image: '/flags/ML.png',
        countryCode: '223',
        ISOAlpha3Code: 'MLI',
        territory: '30001328',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'MT',
        text: 'Malta',
        value: 'MT',
        ISOAlpha3Code: 'MLT',
        territory: '20000228',
        image: '/flags/MT.png',
        countryCode: '356',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'MH',
        text: 'Marshall Islands',
        value: 'MH',
        image: '/flags/MH.png',
        countryCode: '692',
        ISOAlpha3Code: 'MHL',
        territory: '50000019',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
    },
    {
        key: 'MQ',
        text: 'Martinique',
        value: 'MQ',
        image: '/flags/MQ.png',
        countryCode: '596',
        ISOAlpha3Code: 'MTQ',
        territory: '70000065',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'MR',
        text: 'Mauritania',
        value: 'MR',
        image: '/flags/GH.png',
        countryCode: '222',
        ISOAlpha3Code: 'MRT',
        territory: '30001329',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'MU',
        text: 'Mauritius',
        value: 'MU',
        ISOAlpha3Code: 'MUS',
        territory: '30000601',
        image: '/flags/MU.png',
        countryCode: '230',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'YT',
        text: 'Mayotte',
        value: 'YT',
        image: '/flags/YT.png',
        countryCode: '262',
        ISOAlpha3Code: 'MYT',
        territory: '40000611',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Africa',
    },
    {
        key: 'MX',
        text: 'Mexico',
        value: 'MX',
        ISOAlpha3Code: 'MEX',
        territory: '70000003',
        image: '/flags/MX.png',
        countryCode: '52',
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'FM',
        text: 'Micronesia, Federated States of',
        value: 'FM',
        image: '/flags/FM.png',
        countryCode: '691',
        ISOAlpha3Code: 'FSM',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'MD',
        text: 'Moldova, Republic of',
        value: 'MD',
        ISOAlpha3Code: 'MDA',
        territory: '20000229',
        image: '/flags/MD.png',
        countryCode: '373',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'MC',
        text: 'Monaco',
        value: 'MC',
        image: '/flags/MC.png',
        countryCode: '377',
        ISOAlpha3Code: 'MCO',
        territory: '20000230',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'MN',
        text: 'Mongolia',
        value: 'MN',
        ISOAlpha3Code: 'MNG',
        territory: '60040002',
        image: '/flags/MN.png',
        countryCode: '976',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'ME',
        text: 'Montenegro',
        value: 'ME',
        ISOAlpha3Code: 'MNE',
        image: '/flags/ME.png',
        countryCode: '382',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'MS',
        text: 'Montserrat',
        value: 'MS',
        image: '/flags/MS.png',
        countryCode: '1-664',
        ISOAlpha3Code: 'MSR',
        territory: '70000066',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'MA',
        text: 'Morocco',
        value: 'MA',
        ISOAlpha3Code: 'MAR',
        territory: '30001301',
        image: '/flags/MA.png',
        countryCode: '212',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Africa',
    },
    {
        key: 'MZ',
        text: 'Mozambique',
        value: 'MZ',
        ISOAlpha3Code: 'MOZ',
        territory: '30001332',
        image: '/flags/MZ.png',
        countryCode: '258',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'MM',
        text: 'Myanmar',
        value: 'MM',
        image: '/flags/MM.png',
        countryCode: '95',
        ISOAlpha3Code: 'MMR',
        territory: '50000003',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'NA',
        text: 'Namibia',
        value: 'NA',
        ISOAlpha3Code: 'NAM',
        territory: '30000701',
        image: '/flags/NA.png',
        countryCode: '264',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'NR',
        text: 'Nauru',
        value: 'NR',
        image: '/flags/NR.png',
        countryCode: '674',
        ISOAlpha3Code: 'NRU',
        territory: '50000021',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'NP',
        text: 'Nepal',
        value: 'NP',
        ISOAlpha3Code: 'NPL',
        territory: '40000202',
        image: '/flags/NP.png',
        countryCode: '977',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'NL',
        text: 'Netherlands',
        value: 'NL',
        ISOAlpha3Code: 'NLD',
        territory: '20000232',
        image: '/flags/NL.png',
        countryCode: '31',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'NC',
        text: 'New Caledonia',
        value: 'NC',
        image: '/flags/NC.png',
        countryCode: '687',
        ISOAlpha3Code: 'NCL',
        territory: '50003003',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'NZ',
        text: 'New Zealand',
        value: 'NZ',
        ISOAlpha3Code: 'NZL',
        territory: '50000201',
        image: '/flags/NZ.png',
        countryCode: '64',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'NI',
        text: 'Nicaragua',
        value: 'NI',
        image: '/flags/NI.png',
        countryCode: '505',
        ISOAlpha3Code: 'NIC',
        territory: '70000038',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_B2C,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'NE',
        text: 'Niger',
        value: 'NE',
        ISOAlpha3Code: 'NER',
        territory: '30001333',
        image: '/flags/NE.png',
        countryCode: '227',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'NG',
        text: 'Nigeria',
        value: 'NG',
        ISOAlpha3Code: 'NGA',
        territory: '30000801',
        image: '/flags/NG.png',
        countryCode: '234',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'NU',
        text: 'Niue',
        value: 'NU',
        image: '/flags/NU.png',
        countryCode: '683',
        ISOAlpha3Code: 'NIU',
        territory: '50003004',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'APAC',
    },
    {
        key: 'NF',
        text: 'Norfolk Island',
        value: 'NF',
        image: '/flags/NF.png',
        countryCode: '672',
        ISOAlpha3Code: 'NFK',
        territory: '50003005',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'APAC',
    },
    {
        key: 'MP',
        text: 'Northern Mariana Islands',
        value: 'MP',
        image: '/flags/MP.png',
        countryCode: '1-670',
        ISOAlpha3Code: 'MNP',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'NO',
        text: 'Norway',
        value: 'NO',
        image: '/flags/NO.png',
        countryCode: '47',
        ISOAlpha3Code: 'NOR',
        territory: '20000233',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'OM',
        text: 'Oman',
        value: 'OM',
        ISOAlpha3Code: 'OMN',
        territory: '40000403',
        image: '/flags/OM.png',
        countryCode: '968',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'PK',
        text: 'Pakistan',
        value: 'PK',
        ISOAlpha3Code: 'PAK',
        territory: '40000501',
        image: '/flags/PK.png',
        countryCode: '92',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'PW',
        text: 'Palau',
        value: 'PW',
        image: '/flags/PW.png',
        countryCode: '680',
        ISOAlpha3Code: 'PLW',
        territory: '50000026',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_16,
    },
    {
        key: 'PS',
        text: 'Palestinian Territory',
        value: 'PS',
        image: '/flags/PS.png',
        countryCode: '970',
        ISOAlpha3Code: 'PSE',
        territory: '40000219',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'PA',
        text: 'Panama',
        value: 'PA',
        image: '/flags/PA.png',
        countryCode: '507',
        isAmerica: true,
        ISOAlpha3Code: 'PAN',
        territory: '70000039',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'PG',
        text: 'Papua New Guinea',
        value: 'PG',
        image: '/flags/PG.png',
        countryCode: '675',
        ISOAlpha3Code: 'PNG',
        territory: '50000027',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'PY',
        text: 'Paraguay',
        value: 'PY',
        image: '/flags/PY.png',
        countryCode: '595',
        ISOAlpha3Code: 'PRY',
        territory: '70000040',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'PE',
        text: 'Peru',
        value: 'PE',
        image: '/flags/PE.png',
        countryCode: '51',
        ISOAlpha3Code: 'PER',
        territory: '70000041',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'PH',
        text: 'Philippines',
        value: 'PH',
        ISOAlpha3Code: 'PHL',
        territory: '50000004',
        image: '/flags/PH.png',
        countryCode: '63',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'PN',
        text: 'Pitcairn Islands',
        value: 'PN',
        image: '/flags/PN.png',
        countryCode: '64',
        ISOAlpha3Code: 'PCN',
        territory: '50003007',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'APAC',
    },
    {
        key: 'PL',
        text: 'Poland',
        value: 'PL',
        ISOAlpha3Code: 'POL',
        territory: '20000502',
        image: '/flags/PL.png',
        countryCode: '48',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'PT',
        text: 'Portugal',
        value: 'PT',
        ISOAlpha3Code: 'PRT',
        territory: '20000234',
        image: '/flags/PT.png',
        countryCode: '351',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'PR',
        text: 'Puerto Rico',
        value: 'PR',
        image: '/flags/PR.png',
        countryCode: '1-787',
        ISOAlpha3Code: 'PRI',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'QA',
        text: 'Qatar',
        value: 'QA',
        ISOAlpha3Code: 'QAT',
        territory: '40000404',
        image: '/flags/QA.png',
        countryCode: '974',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'RE',
        text: 'Reunion',
        value: 'RE',
        ISOAlpha3Code: 'REU',
        territory: '30001349',
        image: '/flags/RE.png',
        countryCode: '262',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_11,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'RO',
        text: 'Romania',
        value: 'RO',
        ISOAlpha3Code: 'ROU',
        territory: '20000508',
        image: '/flags/RO.png',
        countryCode: '40',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'RW',
        text: 'Rwanda',
        value: 'RW',
        ISOAlpha3Code: 'RWA',
        territory: '30001335',
        image: '/flags/RW.png',
        countryCode: '250',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'BL',
        text: 'Saint Barthelemy',
        value: 'BL',
        image: '/flags/BL.png',
        countryCode: '590',
        ISOAlpha3Code: 'BLM',
        territory: '70000067',
        validateZipCode: false,
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.NONE,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_15,
        region: 'Europe',
    },
    {
        key: 'SH',
        text: 'Saint Helena',
        value: 'SH',
        image: '/flags/SH.png',
        countryCode: '290',
        ISOAlpha3Code: 'SHN',
        territory: '30001350',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
        isAmerica: true,
    },
    {
        key: 'KN',
        text: 'Saint Kitts and Nevis',
        value: 'KN',
        image: '/flags/KN.png',
        countryCode: '1-869',
        ISOAlpha3Code: 'KNA',
        territory: '70000044',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_3,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'LC',
        text: 'Saint Lucia',
        value: 'LC',
        image: '/flags/LC.png',
        countryCode: '1-758',
        ISOAlpha3Code: 'LCA',
        territory: '70000045',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'MF',
        text: 'Saint Martin (French part)',
        value: 'MF',
        image: '/flags/MF.png',
        countryCode: '590',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        ISOAlpha3Code: 'MAF',
        territory: '70000068',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'Europe',
        isAmerica: true,
    },
    {
        key: 'PM',
        text: 'Saint Pierre and Miquelon',
        value: 'PM',
        image: '/flags/PM.png',
        countryCode: '508',
        ISOAlpha3Code: 'SPM',
        territory: '70000069',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Europe',
    },
    {
        key: 'VC',
        text: 'Saint Vincent and the Grenadines',
        value: 'VC',
        image: '/flags/VC.png',
        countryCode: '1-784',
        ISOAlpha3Code: 'VCT',
        territory: '70000048',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'WS',
        text: 'Samoa, the Independent State of',
        value: 'WS',
        image: '/flags/WS.png',
        countryCode: '685',
        ISOAlpha3Code: 'WSM',
        territory: '50000029',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'SM',
        text: 'San Marino',
        value: 'SM',
        image: '/flags/PM.png',
        countryCode: '378',
        ISOAlpha3Code: 'SMR',
        territory: '20000235',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Europe',
    },
    {
        key: 'ST',
        text: 'Sao Tome and Principe',
        value: 'ST',
        image: '/flags/ST.png',
        countryCode: '239',
        ISOAlpha3Code: 'STP',
        territory: '30001337',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'SA',
        text: 'Saudi Arabia',
        value: 'SA',
        ISOAlpha3Code: 'SAU',
        territory: '40000405',
        image: '/flags/SA.png',
        countryCode: '966',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'SN',
        text: 'Senegal',
        value: 'SN',
        image: '/flags/SN.png',
        countryCode: '221',
        ISOAlpha3Code: 'SEN',
        territory: '30001338',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_10,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'RS',
        text: 'Serbia',
        value: 'RS',
        image: '/flags/RS.png',
        countryCode: '381',
        ISOAlpha3Code: 'SRB',
        territory: '20000236',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_APPROVED_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'SC',
        text: 'Seychelles',
        value: 'SC',
        image: '/flags/SC.png',
        countryCode: '248',
        ISOAlpha3Code: 'SYC',
        territory: '30001339',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Africa',
    },
    {
        key: 'SL',
        text: 'Sierra Leone',
        value: 'SL',
        ISOAlpha3Code: 'SLE',
        territory: '30001340',
        image: '/flags/SL.png',
        countryCode: '232',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_8,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'SG',
        text: 'Singapore',
        value: 'SG',
        ISOAlpha3Code: 'SGP',
        territory: '50000005',
        image: '/flags/SG.png',
        countryCode: '65',
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'APAC',
    },
    {
        key: 'SX',
        text: 'Sint Maarten',
        value: 'SX',
        image: '/flags/SX.png',
        countryCode: '1-721',
        ISOAlpha3Code: 'SXM',
        territory: '20000238',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'SK',
        text: 'Slovakia',
        value: 'SK',
        ISOAlpha3Code: 'SVK',
        territory: '20000509',
        image: '/flags/SK.png',
        countryCode: '421',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'SI',
        text: 'Slovenia',
        value: 'SI',
        image: '/flags/SI.png',
        countryCode: '386',
        ISOAlpha3Code: 'SVN',
        territory: '20000510',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_4,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'SB',
        text: 'Solomon Islands',
        value: 'SB',
        image: '/flags/SB.png',
        countryCode: '677',
        ISOAlpha3Code: 'SLB',
        territory: '50000030',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'SO',
        text: 'Somalia',
        value: 'SO',
        image: '/flags/SO.png',
        countryCode: '252',
        ISOAlpha3Code: 'SOM',
        territory: '30001341',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_CIMA_VERY_HIGH_RISK_B2C,
        isRestricted: true,
        tier: mxp_schemas_1.Checkout.Tiers.RESTRICTED,
        region: 'Africa',
    },
    {
        key: 'ZA',
        text: 'South Africa',
        value: 'ZA',
        ISOAlpha3Code: 'ZAF',
        territory: '30001501',
        image: '/flags/ZA.png',
        countryCode: '27',
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'GS',
        text: 'South Georgia and the South Sandwich Islands',
        value: 'GS',
        ISOAlpha3Code: 'SGS',
        image: '/flags/GS.png',
        countryCode: '500',
        region: 'America',
    },
    {
        key: 'SS',
        text: 'South Sudan',
        value: 'SS',
        ISOAlpha3Code: 'SSD',
        image: '/flags/SS.png',
        countryCode: '211',
        isRestricted: true,
        tier: mxp_schemas_1.Checkout.Tiers.RESTRICTED,
        region: 'Africa',
    },
    {
        key: 'ES',
        text: 'Spain',
        value: 'ES',
        ISOAlpha3Code: 'ESP',
        territory: '20000237',
        image: '/flags/ES.png',
        countryCode: '34',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'LK',
        text: 'Sri Lanka',
        value: 'LK',
        ISOAlpha3Code: 'LKA',
        territory: '40000601',
        image: '/flags/LK.png',
        countryCode: '94',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'SD',
        text: 'Sudan',
        value: 'SD',
        image: '/flags/SD.png',
        countryCode: '249',
        ISOAlpha3Code: 'SDN',
        territory: '30001343',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_B2C,
        isRestricted: true,
        tier: mxp_schemas_1.Checkout.Tiers.RESTRICTED,
        region: 'Africa',
    },
    {
        key: 'SR',
        text: 'Suriname',
        value: 'SR',
        ISOAlpha3Code: 'SUR',
        territory: '70000051',
        image: '/flags/SR.png',
        countryCode: '597',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'SJ',
        text: 'Svalbard and Jan Mayen Islands',
        value: 'SJ',
        image: '/flags/SJ.png',
        countryCode: '47',
        ISOAlpha3Code: 'SJM',
        territory: '20000628',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'Europe',
    },
    {
        key: 'SE',
        text: 'Sweden',
        value: 'SE',
        ISOAlpha3Code: 'SWE',
        territory: '20000239',
        image: '/flags/SE.png',
        countryCode: '46',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_2,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'CH',
        text: 'Switzerland',
        value: 'CH',
        ISOAlpha3Code: 'CHE',
        territory: '20000240',
        image: '/flags/CH.png',
        countryCode: '41',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'Europe',
    },
    {
        key: 'TW',
        text: 'Taiwan Area',
        value: 'TW',
        ISOAlpha3Code: 'TWN',
        territory: '60040004',
        image: '/flags/TW.png',
        countryCode: '886',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TJ',
        text: 'Tajikistan',
        value: 'TJ',
        image: '/flags/TJ.png',
        countryCode: '992',
        ISOAlpha3Code: 'TJK',
        territory: '20000241',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TZ',
        text: 'Tanzania',
        value: 'TZ',
        image: '/flags/TZ.png',
        countryCode: '255',
        ISOAlpha3Code: 'TZA',
        territory: '30000901',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'TH',
        text: 'Thailand',
        value: 'TH',
        ISOAlpha3Code: 'THA',
        territory: '50000007',
        image: '/flags/TH.png',
        countryCode: '66',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TL',
        text: 'Timor-Leste',
        value: 'TL',
        image: '/flags/TL.png',
        countryCode: '670',
        ISOAlpha3Code: 'TLS',
        territory: '50000031',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TG',
        text: 'Togo',
        value: 'TG',
        image: '/flags/TG.png',
        countryCode: '228',
        ISOAlpha3Code: 'TGO',
        territory: '30001345',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'TK',
        text: 'Tokelau',
        value: 'TK',
        image: '/flags/TK.png',
        countryCode: '690',
        ISOAlpha3Code: 'TKL',
        territory: '50003011',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TO',
        text: 'Tonga',
        value: 'TO',
        image: '/flags/TO.png',
        countryCode: '676',
        ISOAlpha3Code: 'TON',
        territory: '50000033',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TT',
        text: 'Trinidad and Tobago',
        value: 'TT',
        ISOAlpha3Code: 'TTO',
        territory: '70000003',
        image: '/flags/TT.png',
        countryCode: '1-868',
        isAmerica: true,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
    },
    {
        key: 'TN',
        text: 'Tunisia',
        value: 'TN',
        ISOAlpha3Code: 'TUN',
        territory: '30001301',
        image: '/flags/TN.png',
        countryCode: '216',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Africa',
    },
    {
        key: 'TR',
        text: 'Turkey',
        value: 'TR',
        ISOAlpha3Code: 'TUR',
        territory: '20000242',
        image: '/flags/TR.png',
        countryCode: '90',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'TM',
        text: 'Turkmenistan',
        value: 'TM',
        ISOAlpha3Code: 'TKM',
        image: '/flags/TM.png',
        countryCode: '993',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'TC',
        text: 'Turks and Caicos Islands',
        value: 'TC',
        image: '/flags/TC.png',
        countryCode: '1-649',
        ISOAlpha3Code: 'TCA',
        territory: '20000624',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_6,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'TV',
        text: 'Tuvalu',
        value: 'TV',
        image: '/flags/TV.png',
        countryCode: '688',
        ISOAlpha3Code: 'TUV',
        territory: '50000034',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_13,
        region: 'APAC',
    },
    {
        key: 'UG',
        text: 'Uganda',
        value: 'UG',
        image: '/flags/UG.png',
        countryCode: '256',
        ISOAlpha3Code: 'UGA',
        territory: '30001001',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'UA',
        text: 'Ukraine',
        value: 'UA',
        ISOAlpha3Code: 'UKR',
        territory: '20000503',
        image: '/flags/UA.png',
        countryCode: '380',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_UKRAINE,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_UKRAINE,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'Europe',
    },
    {
        key: 'AE',
        text: 'United Arab Emirates',
        value: 'AE',
        ISOAlpha3Code: 'ARE',
        territory: '40000406',
        image: '/flags/AE.png',
        countryCode: '971',
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'UM',
        text: 'United States Minor Outlying Islands',
        ISOAlpha3Code: 'UMI',
        value: 'UM',
        image: '/flags/UM.png',
        countryCode: '246',
        region: 'APAC',
    },
    {
        key: 'UY',
        text: 'Uruguay',
        value: 'UY',
        image: '/flags/UY.png',
        countryCode: '598',
        ISOAlpha3Code: 'URY',
        territory: '70000054',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_7,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        isAmerica: true,
        region: 'America',
    },
    {
        key: 'UZ',
        text: 'Uzbekistan',
        value: 'UZ',
        image: '/flags/UZ.png',
        countryCode: '998',
        ISOAlpha3Code: 'UZB',
        territory: '20000244',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'VU',
        text: 'Vanuatu',
        value: 'VU',
        image: '/flags/VU.png',
        countryCode: '678',
        ISOAlpha3Code: 'VUT',
        territory: '50000035',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_12,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'VA',
        text: 'Vatican City State (Holy See)',
        value: 'VA',
        ISOAlpha3Code: 'VAT',
        image: '/flags/VA.png',
        countryCode: '379',
        region: 'Europe',
    },
    {
        key: 'VN',
        text: 'Vietnam',
        value: 'VN',
        ISOAlpha3Code: 'VNM',
        territory: '50000006',
        image: '/flags/VN.png',
        countryCode: '84',
        allowAliasChange: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'VG',
        text: 'Virgin Islands (British)',
        value: 'VG',
        image: '/flags/VG.png',
        countryCode: '1',
        ISOAlpha3Code: 'VGB',
        territory: '70000061',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_9,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'VI',
        text: 'Virgin Islands (U.S.)',
        value: 'VI',
        image: '/flags/VI.png',
        countryCode: '1',
        ISOAlpha3Code: 'VIR',
        territory: '70000001',
        isUsTerritory: true,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_US_TERRITORIES_1,
        tier: mxp_schemas_1.Checkout.Tiers.TIER1,
        region: 'America',
        isAmerica: true,
    },
    {
        key: 'WF',
        text: 'Wallis and Futuna',
        value: 'WF',
        image: '/flags/WF.png',
        countryCode: '681',
        ISOAlpha3Code: 'WLF',
        territory: '50003006',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'APAC',
    },
    {
        key: 'EH',
        text: 'Western Sahara',
        value: 'EH',
        image: '/flags/EH.png',
        countryCode: '212',
        ISOAlpha3Code: 'ESH',
        territory: '40000612',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_NON_US_BATCH_14,
        region: 'Africa',
    },
    {
        key: 'YE',
        text: 'Yemen',
        value: 'YE',
        image: '/flags/YE.png',
        countryCode: '967',
        ISOAlpha3Code: 'YEM',
        territory: '40000222',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_AICPA_VERY_HIGH_RISK_B2C,
        tier: mxp_schemas_1.Checkout.Tiers.TIER2,
        region: 'APAC',
    },
    {
        key: 'ZM',
        text: 'Zambia',
        value: 'ZM',
        ISOAlpha3Code: 'ZMB',
        territory: '30001101',
        image: '/flags/ZM.png',
        countryCode: '260',
        minPrecision: mxp_schemas_1.SmartyStreets.PrecisionLevel.LOCALITY,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
    {
        key: 'ZW',
        text: 'Zimbabwe',
        value: 'ZW',
        ISOAlpha3Code: 'ZWE',
        territory: '30001201',
        image: '/flags/ZW.png',
        countryCode: '263',
        B2CFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        B2BFeatureToggle: mxp_schemas_1.Checkout.CheckoutCountriesListToggle.USE_PART_2_ADDITIONAL_COUNTRIES,
        tier: mxp_schemas_1.Checkout.Tiers.TIER3,
        region: 'Africa',
    },
];
exports.CheckoutCountriesListHash = exports.COUNTRIES_LIST.reduce((acc, country) => {
    if (country.ISOAlpha3Code)
        acc[country.ISOAlpha3Code] = country;
    return acc;
}, {});
/**
 * Temp Fix: Transform Kosovo country codes (XKX, XKV) to XK in suggestions.
 * This ensures Vertex & Zuora recognizes the address as Kosovo until it gets resolved by SmartyStreets.
 * ticket number to revisit: BAU-2435
 */
exports.kosovoCodesToTransform = ['XKX', 'XKV'];
exports.normalizeKosovoCountry = (country) => {
    if (exports.kosovoCodesToTransform.includes(country) || country.toLowerCase().includes('kosovo')) {
        return 'XK';
    }
    return country;
};
exports.countriesWithStates = [
    'AUS',
    'BRA',
    'DEU',
    'IND',
    'MYS',
    'MEX',
    'MMR',
    'NZL',
    'NGA',
    'PLW',
    'USA',
];
exports.CheckoutCountriesFilteredListHash = () => {
    const filteredList = exports.COUNTRIES_LIST.reduce((acc, country) => {
        if (country.ISOAlpha3Code) {
            acc[country.ISOAlpha3Code] = country;
        }
        return acc;
    }, {});
    return filteredList;
};
exports.CheckoutCountriesTextToISOAlpha3CodeMap = Object.values(exports.CheckoutCountriesListHash).reduce((acc, country) => {
    acc[country.text] = country.ISOAlpha3Code;
    return acc;
}, {});
exports.ConvertFromISOAlpha3ToISOAlpha2 = (countryCode) => {
    const selectedCountryISO3 = exports.COUNTRIES_LIST.find(country => countryCode === country.ISOAlpha3Code);
    if (selectedCountryISO3)
        return selectedCountryISO3.value;
    return countryCode;
};
exports.ConvertFromISOAlpha3ToText = (countryCode) => {
    const selectedCountryText = exports.COUNTRIES_LIST.find(country => countryCode === country.ISOAlpha3Code);
    if (selectedCountryText)
        return selectedCountryText.text;
    return countryCode;
};
exports.ConvertFromISOAlpha2ToISOAlpha3 = (countryCode) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => countryCode === country.value);
    if (selectedCountryValue)
        return selectedCountryValue.ISOAlpha3Code;
    return countryCode;
};
exports.ConvertFromISOAlpha2ToText = (countryCode) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => countryCode === country.value);
    if (selectedCountryValue)
        return selectedCountryValue.text;
    return countryCode;
};
exports.ConvertFromKeyToISOAlpha3 = (countryCode) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => countryCode === country.key);
    if (selectedCountryValue.ISOAlpha3Code)
        return selectedCountryValue.ISOAlpha3Code;
    return countryCode;
};
exports.ConvertFromTextToISOAlpha3 = (countryText) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => countryText.toLowerCase() === country.text.toLowerCase());
    if (!selectedCountryValue)
        return countryText;
    return selectedCountryValue.ISOAlpha3Code;
};
// Returns null if no country found unlike ConvertFromTextToISOAlpha3 which returns the input text
exports.ConvertFromCountryTextToISOAlpha3 = (countryText) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => countryText.toLowerCase() === country.text.toLowerCase());
    if (selectedCountryValue)
        return selectedCountryValue.ISOAlpha3Code;
    return null;
};
exports.ConvertFromISOToCountryCodeText = (key) => {
    const selectedCountryValue = exports.COUNTRIES_LIST.find(country => key === country.key);
    if (selectedCountryValue)
        return selectedCountryValue.countryCode;
    return key;
};
exports.convertToIsoAlpha2 = (key) => {
    // From Country Text or ISO-Alpha3 to ISO-Alpha2
    const country = exports.COUNTRIES_LIST.find(c => c.text.toLowerCase() === key.toLowerCase() || c.ISOAlpha3Code === key);
    if (country)
        return country.value;
    return 'UNDEFINED';
};
exports.AllUSRegions = [
    exports.CheckoutCountriesListHash.USA.ISOAlpha3Code,
    exports.CheckoutCountriesListHash.PRI.ISOAlpha3Code,
    exports.CheckoutCountriesListHash.GUM.ISOAlpha3Code,
    exports.CheckoutCountriesListHash.VIR.ISOAlpha3Code,
    exports.CheckoutCountriesListHash.MNP.ISOAlpha3Code,
    exports.CheckoutCountriesListHash.ASM.ISOAlpha3Code,
];
exports.checkQualificationStatus = (hasMembershipProduct, isCimaApplicationType, isUserCpaLicensed, learningPathway, isApprenticeLapsedOrSuspendedRenewal, enrollmentStatus) => {
    const isEligible = hasMembershipProduct && (isCimaApplicationType || isUserCpaLicensed);
    // change Not Applicable status to Pending Progression engine run
    if ([mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L4, mxp_schemas_1.MembershipTypes.Pathway.APPRENTICE_L7].includes(learningPathway) &&
        isApprenticeLapsedOrSuspendedRenewal &&
        enrollmentStatus === mxp_schemas_1.Salesforce.CimaStatus.ENROLLED) {
        return mxp_schemas_1.User.QualificationLevelStatus.PendingProgressionEngineRun;
    }
    return isEligible ? user_1.PersonQualificationLevelItems[learningPathway] : '';
};
exports.checkIfAddressIsAmerica = (country) => {
    var _a;
    return (((_a = exports.COUNTRIES_LIST === null || exports.COUNTRIES_LIST === void 0 ? void 0 : exports.COUNTRIES_LIST.find((countryList) => (countryList === null || countryList === void 0 ? void 0 : countryList.ISOAlpha3Code) === country ||
        (countryList === null || countryList === void 0 ? void 0 : countryList.key) === country ||
        (countryList === null || countryList === void 0 ? void 0 : countryList.text) === exports.ConvertFromISOAlpha3ToText(country))) === null || _a === void 0 ? void 0 : _a.isAmerica) || false);
};
/**
 * Validates if a Public Accounting organization has a US address (which is not allowed)
 * @param organizationType - The organization type to check
 * @param addressCountry - The country value from the address
 * @returns boolean - true if it's a Public Accounting org with US address (validation error)
 */
exports.isPublicAccountingWithUSAddress = (organizationType, addressCountry) => {
    // Use the enum value instead of hardcoded string
    const PUBLIC_ACCOUNTING = mxp_schemas_1.MembershipTypes.OrganizationType.PUBLIC_ACCOUNTING;
    const isPublicAccounting = organizationType === PUBLIC_ACCOUNTING;
    const isUSAddress = addressCountry === exports.CheckoutCountriesListHash.USA.ISOAlpha3Code ||
        addressCountry === exports.CheckoutCountriesListHash.USA.text ||
        addressCountry === exports.CheckoutCountriesListHash.USA.value;
    return isPublicAccounting && isUSAddress;
};
exports.RegionList = [
    { name: 'Africa', key: 'Africa' },
    { name: 'Asia-Pacific', key: 'APAC' },
    { name: 'Americas & Europe', key: 'America' },
    { name: 'North Asia', key: 'North Asia' },
];
//# sourceMappingURL=index.js.map